import { FormattedMessage } from "react-intl";

export function RedirectError() {
  return (
    <FormattedMessage defaultMessage="Error: The destination URL is invalid or missing." />
  );
}
